export default __webpack_public_path__ + "static/logo-06b83beafc81c022fe423f1421120e47.svg";